module.exports = __webpack_public_path__ + "static/img/new_bridge.9833c8e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/new_bridge.gif
// module id = iSUU
// module chunks = 1